angular.module('ikeweb.notes', [
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.repository.parse',
    'ikeweb.repository',
    'ikeweb.shared.logging',
    'ikeweb.error',
    'ikeweb.event',
    'LocalStorageModule',
    'pascalprecht.translate'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/notes/notes.module.js
// module id = 419
// module chunks = 0